<template>
  <div class="p-input-component">
    <div class="d-flex align-items-center">
      <label
        :for="id"
        class="form-label"
        v-bind="labelElProps"
      >
        {{ label }}
      </label>
    <div v-if="required" class="required-dot" v-bind="divElProps"/>
    </div>
    <textarea
      :id="id"
      ref="textArea"
      class="form-control"
      :value="value"
      :required="required"
      v-bind="inputProps"
      style="height: 100%; resize: none;"
      :maxlength="maxlength"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event.target.value)"
      @change="$emit('change', $event.target.value)"
      @keyup="$emit('keyup', $event.target.value)"
    />
  </div>
</template>

<script>
import { commonInputProps } from '~/helpers/component-props/input-props'

export default {
  name: 'TextareaField',
  props: {
    ...commonInputProps,
    maxlength: {
      type: Number,
      default: null
    }
  },
  mounted () {
    if (this.autoFocus) {
      this.$refs.textArea.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
.p-input-component {
  .form-label {
    margin-bottom: 5px;
  }
}
.form-control:disabled {
    background-color: #e9ecef !important;
    opacity: 1;
}
</style>
